import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';

const VisitTypeField = () => {
  const { control } = useFormContext();

  return (
    <FormControlLabel
      label="DOES THIS DATASET NEED VISIT TYPE?"
      required
      sx={{ width: 'fit-content' }}
      control={
        <Controller
          name="visit_type"
          control={control}
          disabled
          render={({ field }) => (
            <RadioGroup row {...field} sx={{ gap: 6 }}>
              {[true, false].map((type) => (
                <FormControlLabel
                  key={type.toString()}
                  labelPlacement="end"
                  disabled
                  value={type}
                  control={<Radio />}
                  label={type ? 'Yes' : 'No'}
                />
              ))}
            </RadioGroup>
          )}
        />
      }
    />
  );
};

export default VisitTypeField;
